import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export interface FormComponent {
  isDirty: () => boolean;
}

@Injectable({ providedIn: 'root' })
export class SaveChangesGuard implements CanDeactivate<FormComponent> {
  constructor(private translate: TranslateService) {}

  canDeactivate(component: FormComponent): Observable<boolean> | Promise<boolean> | boolean {
    if (!component.isDirty) {
      return true;
    }

    if (component.isDirty()) {
      return window.confirm(this.translate.instant('generic.alerts.UNSAVED'));
    }

    return true;
  }
}
